// native
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

// addon
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

// service
import { TestsService } from '../../core/services/tests.service';
import { TestBundlesService } from 'app/core/services/test-bundles.service';
import { PreferencesService } from 'app/core/services/preferences.service';
import { MonitorTestService } from 'app/core/services/monitor-test.service';
import { DevicesService } from 'app/core/services/devices.service';
import { AuthService } from 'app/core/services/auth.service';
import { PatientsService } from 'app/core/services/patients.service';
import { StreamingService } from 'app/core/services/streaming.service';
import { DialogService } from 'app/core/services/dialog.service';

// component
import { MonitorBaseComponent } from '../monitor-base.component';

// models
import { MonitorEvent, StereopsisRecord } from '../../models';

//animation
import { fadeAnimation, startList } from '../../animations/animations';

// constant
import { MONITOR_EVENT_TYPE, MONITOR_INACTIVITY_TIMEOUT } from '../../constants';

@Component({
    selector: 'app-monitor-stereopsis-test',
    templateUrl: './monitor-stereopsis.component.html',
    animations: [fadeAnimation, startList],
    standalone: false
})
export class MonitorStereopsisComponent extends MonitorBaseComponent {
  records: StereopsisRecord[] = [];
  lastElementIndex: number = 0;

  isLoading: boolean = true;

  inactivityTimeout = MONITOR_INACTIVITY_TIMEOUT.VISUAL_ACUITY * 1000;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public testService: TestsService,
    public testBundlesService: TestBundlesService,
    public toastService: ToastrService,
    public devicesService: DevicesService,
    public authService: AuthService,
    public patientsService: PatientsService,
    public monitorTestService: MonitorTestService,
    public streamingService: StreamingService,
    public preferencesService: PreferencesService,
    public translateService: TranslateService,
    public dialogService: DialogService) {
    super(route, router, testService, testBundlesService, toastService, devicesService, authService, patientsService,
      monitorTestService, streamingService, preferencesService, translateService, dialogService);
  }

  public getCurrentTestState() {
    this.monitorTestService.getStereopsisState(this.test.id)
      .pipe(
        finalize(() => this.isLoading = false)
      ).subscribe(records => {
        this.renderRecords(<StereopsisRecord[]>records);
      });
  }

  private renderRecords(records: StereopsisRecord[]) {
    records.filter(record => !record.threshold).forEach(record => {
      this.records[record.seq_num - 1] = record;
    });

    this.lastElementIndex = this.getLastElementIndex(this.records);
  }

  private getLastElementIndex(records: StereopsisRecord[]): number {
    return records.length - 1 - records.findIndex(el => !!el);
  }

  isRecordHidden(record: StereopsisRecord, index: number) {
    if (record)
      return false;

    return index > this.lastElementIndex;
  }

  public calculateDimensions() { }

  public handleNewRecordEvent(event: MonitorEvent) {
    if (event.type === MONITOR_EVENT_TYPE.NEW_STEREOPTIS_RECORD)
      this.updateRecords(<StereopsisRecord>event.data);
  }

  private updateRecords(record: StereopsisRecord) {
    this.updateRecord(record);
    this.lastElementIndex = this.getLastElementIndex(this.records);
  }

  private updateRecord(record: StereopsisRecord) {
    if (record.threshold)
      return;
    if (!this.records[0] || (record.seq_num > this.records[0].seq_num))
      this.records[record.seq_num - 1] = record;
  }

  public resetStateAfterReconnection(): void {
    this.records = [];
    this.lastElementIndex = 0;
  }

  public onToggleGrid() { }
}
